// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2vcrc","colLarge":"styles_colLarge__3gBEj","col":"styles_col__1ZDcz","colCheckbox":"styles_colCheckbox__1UBSA","actions":"styles_actions__qaM5v"};